// 两个浮点数求和
export function accAdd(num1, num2) {
    let r1, r2, m;
    try {
        r1 = num1.toString().split('.')[1].length;
    } catch (e) {
        r1 = 0;
    }
    try {
        r2 = num2.toString().split(".")[1].length;
    } catch (e) {
        r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    return Math.round(num1 * m + num2 * m) / m;
}

// 两个浮点数相减
export function accSub(num1, num2) {
    // let r1, r2, m, n;
    let r1, r2, m;
    try {
        r1 = num1.toString().split('.')[1].length;
    } catch (e) {
        r1 = 0;
    }
    try {
        r2 = num2.toString().split(".")[1].length;
    } catch (e) {
        r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    // n = (r1 >= r2) ? r1 : r2;
    const num = Math.round(num1 * m - num2 * m) / m;
    return num;
}
// 两数相除
export function accDiv(num1, num2) {
    let t1, t2, r1, r2;
    try {
        t1 = num1.toString().split('.')[1].length;
    } catch (e) {
        t1 = 0;
    }
    try {
        t2 = num2.toString().split(".")[1].length;
    } catch (e) {
        t2 = 0;
    }
    r1 = Number(num1.toString().replace(".", ""));
    r2 = Number(num2.toString().replace(".", ""));
    return (r1 / r2) * Math.pow(10, t2 - t1);
}

// 自定义保留两位小数
export function formatFloatCeil(num, n = 2) {
    num = +(+num || 0).toFixed(2);
    num = Math.ceil(num);
    num = Math.round(num * Math.pow(10, n)) / Math.pow(10, n);
    return num;
}

export function formatFloatFloor(num, n = 2) {
    num = Math.ceil((+num || 0) * 100) / 100;
    return Math.round(num * Math.pow(10, n)) / Math.pow(10, n);
}
// 两个浮点数相乘
export function accMul(arg1, arg2) {
    var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
    try { m += s1.split(".")[1].length; } catch (e) { }
    try { m += s2.split(".")[1].length; } catch (e) { }
    return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
}

export function matchNumber(str) {
    return str?.match(/\d+\.?\d*/)?.[0];
}